import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, FormGroup, Input} from 'reactstrap';
import trainingPhasesActionCreators from '../../../store/training-phases/action-creators/index';
import Checkbox from '../../../../shared/forms/Checkbox';

class RecallFormForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isReject: false
    };
  }

  // ----------------------
  // Methods
  // ----------------------

  setReject(event) {
    this.setState({
      isReject: event.target.checked,
      isChecked: false
    })
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.isReject) {
      this.props.recallReport(this.props.reportGuid);
    }
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Form noValidate onSubmit={event => this.handleSubmit(event)}>
        <FormGroup>
          <Checkbox
            label="Recall"
            name="approve"
            checked={this.state.isReject}
            onChange={(e) => this.setReject(e)}/>
        </FormGroup>

        {this.state.isReject &&
          <button className="button primary">
            Submit
          </button>
        }
      </Form>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    // TODO
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    recallReport: (formData) => {
      dispatch(trainingPhasesActionCreators.recallReport(formData))
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RecallFormForm);
